import { Dialog } from 'antd-mobile'
import { observer } from 'mobx-react'
import styles from './BiluJumpConfirmPopup.module.less'
import { commonUtils } from '@/helpers/commonUtils'
import { useEffect } from 'react'
import { api } from '@/helpers/api'

export interface BiluJumpConfirmPopupProps {
  visible: boolean
  onClose?: () => void
  onConfirm?: () => void
  launchInfo?: {
    username: any
    path: string
  }
}

const BiluJumpConfirmPopupContent = observer((props: BiluJumpConfirmPopupProps) => {
  useEffect(() => {
    if (!props.visible || !commonUtils.isWechat() || !props.launchInfo) {
      return
    }

    const initWechatOpenTag = async (): Promise<void> => {
      try {
        const wxModule = await import('weixin-js-sdk')
        const wx = (wxModule.default || wxModule) as any
        const currentUrl = window.location.href.split('#')[0]
        const { data } = await api.user.getWechatJsSdkConfig({
          url: currentUrl,
        })

        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: [],
          openTagList: ['wx-open-launch-weapp'],
        })

        wx.ready(() => {
          console.log('wx-open-launch-weapp ready')
        })

        wx.error((error: unknown) => {
          console.error('wx.config error', error)
        })
      } catch (error) {
        console.error('init wx-open-launch-weapp failed', error)
      }
    }

    initWechatOpenTag()
  }, [props.launchInfo, props.visible])

  const shouldUseWechatLaunch =
    commonUtils.isWechat() &&
    !!props.launchInfo?.username &&
    !!props.launchInfo?.path
  const launchTemplate = `<template><button style="display:block;width:100%;height:38px;border:none;border-radius:999px;background:linear-gradient(180deg,#3fc66c 0%,#29b655 100%);color:#fff;font-size:16px;font-weight:600;">确认跳转</button></template>`

  return (
    <div className={styles.biluJumpConfirmPopup}>
      <div className={styles.hero}>
        <img src={commonUtils.getStaticFile('xcx.png')} alt='pay/1' />
      </div>
      <div className={styles.title}>即将打开“笔鹿作文”小程序？</div>
      <div className={styles.btnList}>
        {shouldUseWechatLaunch ? (
          <wx-open-launch-weapp
            id='launch-btn'
            username={props.launchInfo!.username}
            path={props.launchInfo!.path}
            class={styles.confirmLaunch}
            dangerouslySetInnerHTML={{ __html: launchTemplate }}
          />
        ) : (
          <button type='button' className={styles.confirmButton} onClick={() => props.onConfirm?.()}>
            确认跳转
          </button>
        )}
        <button type='button' className={styles.cancelButton} onClick={() => props.onClose?.()}>
          取消
        </button>
      </div>
    </div>
  )
})

const BiluJumpConfirmPopup = observer((props: BiluJumpConfirmPopupProps) => {
  return (
    <Dialog
      style={
        {
          '--max-width': '100vw',
        } as React.CSSProperties
      }
      visible={props.visible}
      onClose={props.onClose}
      closeOnMaskClick
      bodyStyle={{
        padding: 0,
        backgroundColor: 'transparent',
      }}
      content={<BiluJumpConfirmPopupContent {...props} />}
      getContainer={() => document.body}
    />
  )
})

export default BiluJumpConfirmPopup
